import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { expandRatings } from '@/modules/analytics/utils/expandRatings';

import { CsatStarToggles } from './CsatStarToggles';

interface CsatStarPickerProps {
  filterIndex: number;
  valueField: 'ratings' | 'csatBrain';
  modeField: 'ratingsMode' | 'csatBrainMode';
  /** What an older saved filter holds: the star that was clicked, or the stars it matched. */
  legacyValue: 'threshold' | 'stars';
}

export const CsatStarPicker = ({
  filterIndex,
  valueField,
  modeField,
  legacyValue,
}: CsatStarPickerProps) => {
  const { control, getValues } = useFormContext();
  const storedMode = useWatch({ control, name: `filters.${filterIndex}.${modeField}` });
  const storedStars = useWatch({ control, name: `filters.${filterIndex}.${valueField}` }) || [];

  const selected = expandRatings(storedStars, legacyValue === 'stars' ? 'in' : storedMode) ?? [];

  const { update } = useFieldArray({ control, name: 'filters' });

  const handleToggle = (star: number) => {
    const next = selected.includes(star)
      ? selected.filter((selectedStar) => selectedStar !== star)
      : [...selected, star].sort((a, b) => a - b);

    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, [valueField]: next, [modeField]: 'in' });
  };

  return <CsatStarToggles selected={selected} onToggle={handleToggle} />;
};
